import {connect} from 'react-redux';
import './ComparableItemSummaryAug2020.scss';
import ComparableItemSummaryAug2020 from './ComparableItemSummaryAug2020.lazy';
import {comparableListingUpdateFields, getCompItemTitlePrice, getIsFieldVisible, isNZLocale} from 'lib/PropertyUtils';
import {comparableTypeFromPageContext} from 'actionCreators/comparableItems';
import featuredSalesMarker from 'images/featured_sales_marker.png';
import featuredListingsMarker from 'images/featured_listings_marker.png';
import featuredRentalsMarker from 'images/featured_rentals_marker.png';
import {setDisplayField as setDisplaySalesField} from 'actionCreators/comparableSales';
import {setDisplayField as setDisplayListingsField} from 'actionCreators/comparableListings';
import AnalyticsGateway from 'lib/AnalyticsGateway';

const firstListingField = 'firstPublishedPrice';
const lastListingField = 'latestPublishedPrice';
const listingPriceField = comparableListingUpdateFields[0];

const mapStateToProps = (state, ownProps) => {
  const isNZ = isNZLocale();
  const { pageContext: objectContext, property } = ownProps;
  const { displayFields } = property;
  const comparableType = comparableTypeFromPageContext(objectContext);
  const markerImg = comparableType === 'sales' ? featuredSalesMarker
    : comparableType === 'listings' ? featuredListingsMarker
      : featuredRentalsMarker;
  const isFirstListingVisible = getIsFieldVisible(firstListingField, displayFields);
  const isLastListingVisible = getIsFieldVisible(lastListingField, displayFields);
  const isPriceDescriptionVisible = getIsFieldVisible(listingPriceField, displayFields);
  const priceDescription = getCompItemTitlePrice(comparableType, property);

  return {
    ...ownProps,
    objectContext,
    property: {
      ...property,
      [listingPriceField]: priceDescription,
    },
    comparableType,
    markerImg,
    isNZ,
    propertyDetailsSpacing: isNZ ? 4 : 6,
    isFirstListingVisible,
    isLastListingVisible,
    isPriceDescriptionVisible,
  };
};

const mapDispatchToProps = (dispatch, {propertyId}) => {
  const onFirstListingClick = (event) => {
    dispatch(setDisplaySalesField({
      propertyId,
      fieldName: firstListingField,
      descriptiveFieldName: AnalyticsGateway.descriptiveFieldNames[firstListingField],
      visible: event.target.checked,
    }));
  };
  const onLastListingClick = (event) => {
    dispatch(setDisplaySalesField({
      propertyId,
      fieldName: lastListingField,
      descriptiveFieldName: AnalyticsGateway.descriptiveFieldNames[lastListingField],
      visible: event.target.checked,
    }));
  };
  const onPriceDescriptionClick = (event) => {
    dispatch(setDisplayListingsField({
      propertyId,
      fieldName: comparableListingUpdateFields,
      descriptiveFieldName: 'Price Description',
      visible: event.target.checked,
    }));
  };
  return {
    onFirstListingClick,
    onLastListingClick,
    onPriceDescriptionClick,
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

/**
 * Component for comparable sales and comparable listings.
 */
const ComparableItemSummaryAug2020Container = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ComparableItemSummaryAug2020);

export {ComparableItemSummaryAug2020Container, ComparableItemSummaryAug2020};
export default ComparableItemSummaryAug2020Container;
